import { SEARCH_APPLIANCE_CATEGORY_ID } from "@/types/search";
import { EOJ_ID } from "@/const/common-const";

export const getApplianceCategoryBlackIcon = (applianceCategoryId: number) => {
  let icon = null;
  switch (applianceCategoryId) {
    case SEARCH_APPLIANCE_CATEGORY_ID.MICRO_WAVE_OVEN:
      icon = require("@/assets/images/hm_icon02.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER:
      icon = require("@/assets/images/hm_icon08.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER_AUTO_WEIGHTING:
      icon = require("@/assets/images/icon_autorc_b.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.IH_COOKING_HEATER:
      icon = require("@/assets/images/hm_icon10.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.REFRIGERATOR:
      icon = require("@/assets/images/hm_icon12.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.HOME_BAKERY:
      icon = require("@/assets/images/hm_icon14.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.DESKTOP_IH:
      icon = require("@/assets/images/ihch_01.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.AUTO_COKKER:
      icon = require("@/assets/images/ac_01.png");
      break;
  }
  return icon;
};

export const getApplianceCategoryWhiteIcon = (applianceCategoryId: number) => {
  let icon = null;
  switch (applianceCategoryId) {
    case SEARCH_APPLIANCE_CATEGORY_ID.MICRO_WAVE_OVEN:
      icon = require("@/assets/images/hm_icon01.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER:
      icon = require("@/assets/images/hm_icon09.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER_AUTO_WEIGHTING:
      icon = require("@/assets/images/icon_autorc_w.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.IH_COOKING_HEATER:
      icon = require("@/assets/images/hm_icon11.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.REFRIGERATOR:
      icon = require("@/assets/images/hm_icon13.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.HOME_BAKERY:
      icon = require("@/assets/images/hm_icon15.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.DESKTOP_IH:
      icon = require("@/assets/images/ihch_02.png");
      break;
    case SEARCH_APPLIANCE_CATEGORY_ID.AUTO_COKKER:
      icon = require("@/assets/images/ac_02.png");
      break;
  }
  return icon;
};

export const getEojBlackIcon = (eoj: string) => {
  let icon = null;
  switch (eoj) {
    case EOJ_ID.MICRO_WAVE_OVEN:
      icon = require("@/assets/images/hm_icon02.png");
      break;
    case EOJ_ID.RICE_COOKER:
      icon = require("@/assets/images/hm_icon08.png");
      break;
    case EOJ_ID.RICE_COOKER_AUTO_WEIGHTING:
      icon = require("@/assets/images/icon_autorc_b.png");
      break;
    case EOJ_ID.IH_COOKING_HEATER:
      icon = require("@/assets/images/hm_icon10.png");
      break;
    case EOJ_ID.DESKTOP_IH:
      icon = require("@/assets/images/ihch_01.png");
      break;
    case EOJ_ID.AUTO_COKKER:
      icon = require("@/assets/images/ac_01.png");
      break;
  }
  return icon;
}